import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody, Button, Spinner, Badge } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import Select from "react-select"

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next"
import { debounce, map, range } from "lodash"

import ToolkitProvider from "react-bootstrap-table2-toolkit"

//actions

import "../../assets/scss/datatables.scss"

import MyPagination from "components/Common/MyPagination"
import DeleteModal from "components/Common/DeleteModal"
import { AvField, AvForm } from "availity-reactstrap-validation"
import BranchModal from "./Crud/Modal"
import {
  deleteBranch,
  getBranches,
  getDistricts,
  getStates,
} from "store/actions"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import { useRole, ROLE_TYPES } from "hooks/useRole"

const Branches = () => {
  const { isAnyRole } = useRole()
  const dispatch = useDispatch()
  const history = useHistory()
  const [page, setPage] = useState(1)
  const [branchModal, setBranchModal] = useState({ status: false, data: {} })

  const [searchText, setSearchText] = useState("")
  const [totalListLimit, setTotalListLimit] = useState(10)

  const [state, setState] = useState("Select State...")
  const [stateId, setStateId] = useState("")
  const [stateSearch, setStateSearch] = useState("")

  const [district, setDistrict] = useState("Select District...")
  const [districtId, setDistrictId] = useState(null)
  const [districtSearch, setDistrictSearch] = useState("")

  const { loading, branches, allState, allDistricts } = useSelector(state => ({
    loading: state.Branches.loading,
    branches: state.Branches.branches,
    allState: state?.Client?.states?.States,
    allDistricts: state?.Client?.districts?.districts,
  }))

  const tableBranchData = branches || {}

  const totalPages = Math.ceil(tableBranchData?.total / 10)
  const pages = range(1, totalPages + 1)

  useEffect(() => {
    dispatch(getBranches(page, totalListLimit, searchText, stateId, districtId))
  }, [dispatch, page, totalListLimit, searchText, stateId, districtId])

  const updatedLocation = {
    ...location,
    state: {
      ...location.state,
      page: 1,
    },
  }

  const [isOpen, setIsOpen] = useState({ status: false, id: "" })

  const handleDelete = id => {
    setIsOpen({ status: true, id: id })
  }

  const handleDeleteEvent = () => {
    setIsOpen({ ...isOpen, status: false })
    dispatch(deleteBranch(isOpen?.id))
  }

  const columns = [
    {
      dataField: "no",
      text: "Sl.No",
    },
    {
      dataField: "branch_name",
      text: "Branch Name",
      sort: true,
    },
    {
      dataField: "photo",
      text: "Photo",
    },
    // {
    //   dataField: "description",
    //   text: "Description",
    //   sort: true,
    // },

    {
      dataField: "location",
      text: "Location",
      sort: true,
    },
    {
      dataField: "adminName",
      text: "Branch Admin",
      sort: true,
    },

    {
      dataField: "action",
      text: "Action",
    },
  ]

  const handleColumns = () => {
    if (isAnyRole([ROLE_TYPES.SALES_MANAGER])) {
      return columns?.filter(i => i.dataField !== "action")
    } else return columns
  }

  const tableData = map(tableBranchData?.branches || [], (item, index) => ({
    ...item,
    no: index + 1,
    photo: (
      <>
        {item?.image?.[0]?.url ? (
          <img
            src={item?.image?.[0]?.url}
            alt={item?.image?.[0]?.public_id}
            style={{ width: 40, height: 40, borderRadius: "50%" }}
          />
        ) : (
          <Badge
            className={
              "font-size-16 badge-soft-warning d-flex align-items-center justify-content-center px-2 py-1 me-2"
            }
            color=""
            pill
            style={{ width: 40, height: 40, borderRadius: "50%" }}
          >
            <p className="m-0 p-0"> {item?.branch_name?.slice(0, 1)}</p>
          </Badge>
        )}
      </>
    ),
    // description: (
    //   <>
    //     {item?.description?.length && (
    //       <UncontrolledTooltip
    //         placement="bottom"
    //         target={`description-${item?._id}`}
    //       >
    //         {item?.description || ""}
    //       </UncontrolledTooltip>
    //     )}
    //     <div
    //       style={{ whiteSpace: "break-spaces" }}
    //       id={`description-${item?._id}`}
    //     >
    //       {(item?.description || "").slice(0, 110)}
    //       {(item?.description || "").length > 110 ? "..." : ""}
    //     </div>
    //   </>
    // ),
    location: (
      <>
        <b style={{ fontSize: "14px" }}>{item?.location || "--"}</b>
        <p style={{ fontWeight: 100 }}>
          {item?.state?.name}
          {item?.district?.name ? "," : ""} {item?.district?.name}
        </p>
      </>
    ),
    adminName: (
      <>
        <b style={{ fontSize: "14px" }}>{item?.branch_admin?.name || "---"}</b>
        <br />
        <span style={{ fontWeight: 100 }}>{item?.branch_admin?.phone}</span>
        <p style={{ fontWeight: 100 }}>{item?.branch_admin?.email}</p>
      </>
    ),
    action: (
      <div>
        <Button
          id={`view${index}`}
          type="button"
          color="white"
          className="ms-1 btn"
          onClick={() => {
            setBranchModal({ status: true, data: item })
          }}
        >
          <i
            className="bx bx-edit-alt me-2"
            style={{ color: "green", fontSize: "22px" }}
          />
        </Button>
        <>
          <Button
            id={`Delete${index}`}
            type="button"
            color="white"
            className="ms-1 btn "
            onClick={() => {
              handleDelete(item._id)
            }}
          >
            <i
              className="bx bx-trash me-2"
              style={{
                color: "red",
                marginBottom: "10px",
                fontSize: "1.3rem",
              }}
            />
          </Button>
        </>
      </div>
    ),
  }))

  const debounceBranchSearch = debounce(value => {
    setSearchText(value)
    history.push(updatedLocation)
  }, 600)

  const handlePageLimit = count => {
    setTotalListLimit(count)
  }

  // states

  useEffect(() => {
    dispatch(getStates(stateSearch))
  }, [dispatch, stateSearch])

  const stateOptions = [
    {
      label: "All",
      value: "",
    },
    {
      options: allState?.map((result, index) => ({
        key: index,
        label: result?.name,
        value: result?._id,
      })),
    },
  ]

  const handleEnteredStates = textEntered => {
    setStateSearch(textEntered)
  }

  function handleFinalValuesStates(event) {
    setState(event.label)
    setStateId(event.value)
    history.push(updatedLocation)
  }

  useEffect(() => {
    dispatch(getDistricts(stateId, districtSearch))
  }, [dispatch, stateId, districtSearch])

  const districtOptions = [
    {
      label: "All",
      value: "",
    },
    {
      options: allDistricts?.map((result, index) => ({
        key: index,
        label: result?.name,
        value: result._id,
      })),
    },
  ]

  const handleEnteredDistrict = textEntered => {
    setDistrictSearch(textEntered)
  }

  function handleFinalValuesDistrict(event) {
    setDistrict(event.label)
    setDistrictId(event.value)
    history.push(updatedLocation)
  }

  return (
    <React.Fragment>
      <Row>
        <DeleteModal
          show={isOpen?.status}
          onCloseClick={() => setIsOpen({ ...isOpen, status: false })}
          onDeleteClick={handleDeleteEvent}
        />
        <BranchModal
          onCloseClick={() => setBranchModal({ status: false, data: {} })}
          show={branchModal?.status}
          updateData={branchModal?.data}
        />
        <Col className="col-12">
          <Card>
            <CardBody>
              <ToolkitProvider
                keyField="_id"
                key={"id"}
                columns={handleColumns()}
                data={tableData}
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <div className="d-flex align-items-center justify-content-between p-1 mb-2">
                      {/* <div className="d-flex w-100"> */}
                      <div className="">
                        <div
                          className="search-box  d-inline-block w-100"
                          style={{ minWidth: "250px", maxWidth: "400px" }}
                        >
                          <div className="position-relative mx-0">
                            <AvForm>
                              <AvField
                                name="searchText"
                                placeholder="Search branch, location..."
                                type="text"
                                value={searchText}
                                onChange={e =>
                                  debounceBranchSearch(e.target.value)
                                }
                              />
                            </AvForm>
                            <i className="bx bx-search-alt search-icon" />
                          </div>
                        </div>{" "}
                      </div>

                      <div>
                        <AvForm className="form-horizontal mx-2 d-flex align-items-center w-75">
                          <div className="mx-2">
                            <span className="">Show</span>
                          </div>
                          <div className="" style={{ width: "50px" }}>
                            <AvField
                              name="pageLimit"
                              className="form-control"
                              value={totalListLimit}
                              onChange={e => handlePageLimit(e.target.value)}
                              type="text"
                              required
                            />
                          </div>
                        </AvForm>
                      </div>

                      <div className="w-25 mx-1 mb-1">
                        <Select
                          onInputChange={handleEnteredStates}
                          value={state}
                          placeholder={state}
                          onChange={handleFinalValuesStates}
                          options={stateOptions}
                          classNamePrefix="select2-selection"
                          isLoading={""}
                        />
                      </div>
                      <div className="w-25 mb-1">
                        <Select
                          onInputChange={handleEnteredDistrict}
                          value={district}
                          placeholder={district}
                          onChange={handleFinalValuesDistrict}
                          options={districtOptions}
                          classNamePrefix="select2-selection"
                          isLoading={""}
                        />
                      </div>
                      {/* </div> */}
                      <Button
                        type="button"
                        color="warning"
                        className="btn-rounded  mb-2 me-2 "
                        onClick={() => setBranchModal({ status: true })}
                      >
                        <i className="mdi mdi-plus me-1" />
                        New Branch
                      </Button>
                    </div>

                    {loading ? (
                      <Spinner color="secondary" className="d-block m-auto" />
                    ) : (
                      <>
                        {tableBranchData?.total >= 1 ? (
                          <>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField={"id"}
                                    key={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    // selectRow={selectRow}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    // onTableChange={handleTableChange}
                                    // {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>

                            <MyPagination
                              totalPages={pages}
                              page={page}
                              setPage={setPage}
                            />
                          </>
                        ) : (
                          <p className="my-4 mx-3 ">No Branches !</p>
                        )}
                      </>
                    )}
                  </React.Fragment>
                )}
              </ToolkitProvider>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default Branches
